import React, {useEffect, useState} from 'react';
import {
  Alert,
  Linking,
  ScrollView,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';

import {useNavigation} from '@react-navigation/native';
import Header from '../../components/Header/Header';
import SearchHeader from '../../components/SearchHeader/SearchHeader';
import TemporaryPasswordBanner from '../../components/TemporaryPasswordBanner/TemporaryPasswordBanner';
import {Colors} from '../../constants/Colors';
import ProfileService from '../../services/ProfileService/ProfileService';
import Input from '../../components/Input/Input';
import {Button} from 'react-native-share';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import {useUserStore} from '../../store/UserStore';
import EquipamentsService from '../../services/EquipamentsService/EquipamentsService';
import Toast from '../../components/Toast/Toast';
import ToastDismissible from '../../components/Toast/ToastDismissible';
import DropDownMenu from '../Home/components/DropDownMenu/DropDownMenu';
import EquipmentTermsModal from '../../components/EquipmentTermsModal/EquipmentTermsModal';
import { getAnalytics, logEvent } from '@react-native-firebase/analytics';
import { showSuccess } from '../../utils/globalAlert';

const RequestEquipament = () => {
  const {goBack} = useNavigation();
  const {user} = useUserStore();
  const temporaryPasswordLogin = useUserStore(state => state.temporaryPasswordLogin);

  const [clientData, setClientData] = useState();
  const [description, setDescription] = useState<string>('');
  const [toastVisible, setToastVisibility] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState<string>('');
  const [termsVisible, setTermsVisible] = useState(false);

  const analyticsInstance = getAnalytics();
  const sendEquipmentRequest = async () => {
    if (selectedEquipment?.trim() === '') {
      Alert.alert('Informe sua solicitação', 'Marque qual equipamento deseja!');
      return;
    }

    const data = {
      client_id: user?.current_client?.id,
      equipment: selectedEquipment,
    };
    try {
      const response = await EquipamentsService.EquipmentRequest(data);
      logEvent(analyticsInstance, 'equipment_request', {
        client_code: user?.clientCode,
        equipment: selectedEquipment,
      });
      showSuccess(
        'Solicitação realizada',
        'Em breve, um consultor\nentrará em contato.',
      );
      goBack();
    } catch (e) {
      Alert.alert(
        '',
        'Ocorreu um erro ao criar a solicitação.\nTente novamente mais tarde.',
      );
      goBack();
    }
  };

  const handleDecision = (accepted: boolean) => {

    console.log('accepted')
    console.log(accepted)
    setTermsVisible(false);
    if (!accepted) {
      goBack();
    } else {
      sendEquipmentRequest();
    }
  };

  const getGeneralInfo = async () => {
    try {
      const response = await ProfileService.GetGeneralClientInfo();
      setClientData(response);
      // setPreference({
      //   acceptMail: response?.accepted?.acceptMail,
      //   acceptMessages: response?.accepted?.acceptMessages,
      // });
    } catch (error) {
      console.error(error);
    }
  };

  function formatPhoneNumber(number: string) {
    const cleaned = number ? number.toString().replace(/\D/g, '') : ''; // Remove qualquer caractere não numérico
    const match = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);

    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }

    return number; // Retorna o número original se não corresponder ao formato esperado
  }

  useEffect(() => {
    getGeneralInfo();
  }, []);

  return (
    <ScrollView
      style={{
        flex: 1,
        backgroundColor: 'white',
        paddingHorizontal: 20,
        paddingVertical: 15,
      }}>
      <Header />
      <View
        style={{
          marginTop: 30,
        }}>
        <SearchHeader onPress={goBack} title="Seus equipamentos" mb={10} />
      </View>
      <TemporaryPasswordBanner />
      <Text
        style={{
          fontSize: 22,
          lineHeight: 26,
          fontFamily: 'TCCC-UnityText Bold',
          color: 'black',
          alignSelf: 'center',
          textAlign: 'center',
          marginTop: 60,
        }}>
        Solicite um equipamento
      </Text>
      <View style={{marginTop: 20}}>
        <ButtonComponent
          outlined={selectedEquipment !== 'Geladeira VB 18'}
          title="Geladeira VB 18"
          width="100%"
          onPress={() => setSelectedEquipment('Geladeira VB 18')}
        />
      </View>
      <View style={{marginTop: 10}}>
        <ButtonComponent
          outlined={selectedEquipment !== 'Geladeira VB 43'}
          title="Geladeira VB 43"
          width="100%"
          onPress={() => setSelectedEquipment('Geladeira VB 43')}
        />
      </View>

      <View
        style={{
          marginTop: 50,
        }}>
        <ButtonComponent
          title="Solicitar"
          width="100%"
          disabled={temporaryPasswordLogin}
          onPress={() => setTermsVisible(true)}
        />
      </View>
      <View
        style={{
          marginTop: 50,
        }}>
        <Text
          style={{
            textAlign: 'center',
            alignSelf: 'center',
            fontSize: 16,
            lineHeight: 22,
            fontFamily: 'TCCC-UnityHeadline Regular',
            color: Colors.GrayPallete.lightgrayThree,
          }}>
          Fale diretamente com um de nossos atendentes ligando para:{' '}
        </Text>
        <TouchableOpacity onPress={() => Linking.openURL('tel:0800 061 5000')}>
          <Text
            style={{
              fontSize: 18,
              color: 'black',
              textAlign: 'center',
              fontFamily: 'TCCC-UnityHeadline Bold',
            }}>
            {'\n'}
            0800 061 5000
          </Text>
        </TouchableOpacity>
      </View>
      {clientData?.commercial && clientData?.commercial?.cellphone && (
        <>
          <Text
            style={{
              textAlign: 'center',
              alignSelf: 'center',
              fontSize: 16,
              lineHeight: 19,
              fontFamily: 'TCCC-UnityHeadline Regular',
              marginTop: 80,
              maxWidth: 200,
              color: Colors.GrayPallete.lightgrayThree,
            }}>
            Ou entre em contato com o seu vendedor que está disponível para te
            atender.
          </Text>
          <View
            style={{
              marginTop: 60,
            }}>
            <Text
              style={{
                textAlign: 'center',
                alignSelf: 'center',
                fontSize: 16,
                lineHeight: 19,
                fontFamily: 'TCCC-UnityHeadline Regular',
                color: 'black',
              }}>
              {clientData?.commercial?.figureName}
            </Text>
            <TouchableOpacity
              onPress={() =>
                Linking.openURL(`tel:` + clientData?.commercial?.cellphone)
              }>
              <Text
                style={{
                  textAlign: 'center',
                  alignSelf: 'center',
                  color: 'black',
                  fontSize: 18,
                }}>
                {formatPhoneNumber(clientData?.commercial?.cellphone)}
              </Text>
            </TouchableOpacity>
          </View>
        </>
      )}
      <ToastDismissible
        title="teste"
        visible={toastVisible}
        onHide={() => setToastVisibility(false)}
      />

      <EquipmentTermsModal
        termsVisible={termsVisible}
        setTermsVisible={setTermsVisible}
        type={2}
        decision={handleDecision}
      />
    </ScrollView>
  );
};

export default RequestEquipament;
